var r=function(){for(var r=[],n=0;n<arguments.length;n++)r[n]=arguments[n];return r.reduce(function(r,n){if(null!=n)if("string"==typeof n)r.push(n);else for(var e in n)n[e]&&r.push(e);return r},[]).join(" ")};export{r as classNames};
//# sourceMappingURL=index.js.map
